import moment from "moment";
import api from "../../../../api";
import { getCurrentUserRole, medrepExt } from "modules/utilities/utility";

export function getReportData(startDate, endDate, tag, queryParams = "") {
  const apiEndpoint = medrepExt.includes(getCurrentUserRole())
    ? `/v3/engagements-report?tag=${tag}&startDate=${startDate}&endDate=${endDate}${queryParams}`
    : `v2/engagements-report?tag=${tag}&startDate=${startDate}&endDate=${endDate}${queryParams}`;
  return api.get(apiEndpoint);
}

export function getEngagementReportData(startDate, endDate, tag, queryParams, pageNumber, pageSize) {
  const query = queryParams.length > 0 ? queryParams + `&pageNumber=${pageNumber}&pageSize=${pageSize}` : `&pageNumber=${pageNumber}&pageSize=${pageSize}` 
  const apiEndpoint = medrepExt.includes(getCurrentUserRole())
    ? `/v3/engagements-report?tag=${tag}&startDate=${startDate}&endDate=${endDate}${query}`
    : `v2/engagements-report?tag=${tag}&startDate=${startDate}&endDate=${endDate}${query}`;
  return api.get(apiEndpoint);
}

export function downloadEngagementReportDatav2(startDate, endDate, tag, queryParams) {
  // return api.get(`/download-engagement-report-v2?tag=${tag}&startDate=${moment(startDate).startOf('days').valueOf()}&endDate=${moment(endDate).endOf('days').valueOf()}${queryParams}`);
   return api.get(`/v2/download-report?tag=${tag}&startDate=${moment(startDate).startOf('days').valueOf()}&endDate=${moment(endDate).endOf('days').valueOf()}${queryParams}`);

}

export function downloadEngagementReportData(startDate, endDate, tag, queryParams) {
  return api.get(`/download-engagements-report?tag=${tag}&startDate=${moment(startDate).valueOf()}&endDate=${moment(endDate).valueOf()}${queryParams}`);
}